import React, { useEffect, useRef } from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import EmailIcon from '@material-ui/icons/Email';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import GlobalTicketDetails from './GlobalTicketDetails/GlobalTicketDetails';
import WagonDetails from '../WagonDetails/WagonDetails';
import AnomalyDetails from './AnomalyDetails/AnomalyDetails';
import HistoricPopUp from './HistoricPopUp/HistoricPopUp';
import SuccessPopUp from './SuccessPopUp/SuccessPopUp';
import SuccessUpdateAlert from './SuccessUpdateAlert';
import {
  ticketNumberState,
  addTicketState,
  setEditTicket,
  setTicketNumber,
} from '../HomePage/ContentTabs/ContentTabsSlice';
import { userInfoState } from '../HomePage/HomeSlice';
import {
  editedTicketState,
  requireMailNotificationState,
  titleUpdateNotificationState,
  setTitleUpdateNotification,
  setRequireMailNotification,
  validationErrorsMultiLangState,
  ticketStatusState,
  setEditedTicket,
  setValidationErrorsMultiLang,
  setTicketStatus,
} from '../EditTicket/EditTicketSlice';
import i18n from '../../i18n';
import ApiService from '../../services/ApiService';
import useStyles from './styles';
import EmailPopUp from '../EmailPopUp/EmailPopUp';
import InvoicesList from './InvoicesList/InvoicesList';

export default function TicketDetailsPage() {
  const classes = useStyles();
  const ticketNumber = useSelector(ticketNumberState);
  const addTicket = useSelector(addTicketState);
  const ticket = useSelector(editedTicketState);
  const requireMailNotification = useSelector(requireMailNotificationState);
  const titleUpdateNotification = useSelector(titleUpdateNotificationState);
  const ticketStatus = useSelector(ticketStatusState);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector(userInfoState);
  const [historicOpened, setHistoricOpened] = React.useState(false);
  const [emailOpened, setEmailOpened] = React.useState(false);
  const [expandedGlobalTicketDetails, setExpandedGlobalTicketDetails] =
    React.useState(true);
  const [expandedWagonDetails, setExpandedWagonDetails] = React.useState(false);
  const [expandedAnomalyDetails, setExpandedAnomalyDetails] = React.useState(
    [],
  );
  const [expandedInvoicesList, setExpandedInvoicesList] = React.useState(false);

  const [expandedAll, setExpandedAll] = React.useState(false);
  const [collapsedAll, setCollapsedAll] = React.useState(false);
  const [displaySuccessPopup, setDisplaySuccessPopup] = React.useState(
    titleUpdateNotification !== null,
  );
  const [statusError, setStatusError] = React.useState(null);
  const [anomalyErrors, setAnomalyErrors] = React.useState([]);
  const [triggerEmailPopUp, setTriggerEmailPopUp] = React.useState('');
  const lang = i18n.language;
  const validationErrorsMultiLang = useSelector(validationErrorsMultiLangState);
  const mountedRef = useRef(true);
  const history = useHistory();
  const ticketNumberParam = useParams().ticketNumber;
  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  async function getTicketDetails(param) {
    const result = await ApiService.getTicketDetails(param);
    if (user.internal || user.hasEmilyDRights || user.externalMax) {
      dispatch(setTicketNumber(result.data.ticket.ticketNumber));
      dispatch(setEditedTicket(result.data.ticket));
      dispatch(setTicketStatus(result.data.ticket.ticketStatus));
    } else {
      dispatch(setTicketNumber(result.data.ticketNumber));
      dispatch(setEditedTicket(result.data));
      dispatch(setTicketStatus(result.data.ticketStatus));
    }
    dispatch(setValidationErrorsMultiLang(result.data.validationErrors));
  }

  useEffect(() => {
    getTicketDetails(ticketNumberParam);
  }, [ticketNumberParam]);

  useEffect(() => {
    if (lang === 'fr' && validationErrorsMultiLang.errorsFR !== undefined) {
      setStatusError(validationErrorsMultiLang.errorsFR.statusError);
      setAnomalyErrors(validationErrorsMultiLang.errorsFR.anomalyErrors);
    } else if (
      lang === 'de' &&
      validationErrorsMultiLang.errorsDE !== undefined
    ) {
      setStatusError(validationErrorsMultiLang.errorsDE.statusError);
      setAnomalyErrors(validationErrorsMultiLang.errorsDE.anomalyErrors);
    } else if (validationErrorsMultiLang.errorsEN !== undefined) {
      setStatusError(validationErrorsMultiLang.errorsEN.statusError);
      setAnomalyErrors(validationErrorsMultiLang.errorsEN.anomalyErrors);
    }
  }, [lang, validationErrorsMultiLang]);
  useEffect(() => {
    setExpandedAll(
      expandedGlobalTicketDetails &&
        expandedWagonDetails &&
        expandedAnomalyDetails.length > 0 &&
        expandedAnomalyDetails.reduce(
          (accumulator, currentValue) => accumulator && currentValue,
        ),
    );
    setCollapsedAll(
      !(
        expandedGlobalTicketDetails ||
        expandedWagonDetails ||
        (expandedAnomalyDetails.length > 0 &&
          expandedAnomalyDetails.reduce(
            (accumulator, currentValue) => accumulator || currentValue,
          ))
      ),
    );
  }, [
    expandedGlobalTicketDetails,
    expandedWagonDetails,
    expandedAnomalyDetails,
  ]);
  useEffect(() => {
    if (mountedRef.current) {
      if (ticketNumber !== '' || addTicket) {
        const expandedAnomalies = Array(ticket.anomalies.length).fill(true);
        setExpandedAnomalyDetails(expandedAnomalies);
      }
    }
  }, [ticketNumber]);

  useEffect(() => {
    return () => {
      if (
        history.action === 'POP' &&
        history.location.pathname.startsWith('/ticket/edit')
      ) {
        history.go(-2);
      }
    };
  }, [history]);

  function updateExpandedAnomalies(index, newExpanded) {
    const anomliesDetails = expandedAnomalyDetails.slice();
    anomliesDetails[index] = newExpanded;
    setExpandedAnomalyDetails(anomliesDetails);
  }

  const handleChange = (panel, index) => (event, newExpanded) => {
    switch (panel) {
      case 'globalTicketDetails':
        setExpandedGlobalTicketDetails(newExpanded);
        break;
      case 'wagonDetails':
        setExpandedWagonDetails(newExpanded);
        break;
      case 'anomalyDetails':
        updateExpandedAnomalies(index, newExpanded);
        break;
      case 'invoicesList':
        setExpandedInvoicesList(newExpanded);
        break;
      default:
        break;
    }
  };

  const handleExpandAll = () => {
    setExpandedGlobalTicketDetails(true);
    setExpandedWagonDetails(true);
    setExpandedInvoicesList(true);
    const newExpandAllAnomalies = expandedAnomalyDetails.map(() => true);
    setExpandedAnomalyDetails(newExpandAllAnomalies);
  };

  const handleCollapseAll = () => {
    setExpandedGlobalTicketDetails(false);
    setExpandedWagonDetails(false);
    setExpandedInvoicesList(false);
    const newCollapseAllAnomalies = expandedAnomalyDetails.map(() => false);
    setExpandedAnomalyDetails(newCollapseAllAnomalies);
  };

  const handleHistoricOpenOrClose = () => {
    if (mountedRef.current) {
      setHistoricOpened(!historicOpened);
    }
  };

  function handleEmailPopUpOpenOrClose(page) {
    setTriggerEmailPopUp(page);
    if (mountedRef.current) {
      setEmailOpened(!emailOpened);
    }
  }
  function editTicket() {
    dispatch(setEditTicket(true));
    history.push(`/ticket/edit/${ticket.ticketNumber}`);
  }
  function handleClickOnEmail() {
    setEmailOpened(true);
  }
  function closeSuccessPopUp() {
    dispatch(setTitleUpdateNotification(null));
    dispatch(setRequireMailNotification(false));
    setDisplaySuccessPopup(false);
  }
  return (
    <div className={classes.root}>
      {(user.hasAllRights || user.hasEmilyDRights) && (
        <IconButton
          aria-label="email"
          className={classes.emailButton}
          onClick={handleClickOnEmail}
        >
          <EmailIcon />
        </IconButton>
      )}
      {(user.hasAllRights ||
        (ticketStatus !== 'CLOSED' && ticketStatus !== 'Ticket closed')) && (
        <IconButton
          aria-label="edit"
          className={classes.editButton}
          onClick={editTicket}
        >
          <EditIcon />
        </IconButton>
      )}
      <Grid container spacing={0}>
        <Grid item xs={8}>
          <Typography className={classes.title}>
            {t('Ticket details')} {ticketNumber}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Grid container justify="flex-end" alignItems="flex-end">
            <Button
              size="small"
              disableRipple
              className={classes.button}
              color="secondary"
              onClick={() => handleExpandAll()}
            >
              <Typography
                className={
                  expandedAll ? classes.expandButton : classes.collapseButton
                }
              >
                {t('Expand all')}
              </Typography>
            </Button>
            <Button
              size="small"
              disableRipple
              className={classes.button}
              color="secondary"
              onClick={() => handleCollapseAll()}
            >
              <Typography
                className={
                  collapsedAll ? classes.expandButton : classes.collapseButton
                }
              >
                {t('Collapse all')}
              </Typography>
            </Button>
            {(user.hasAllRights ||
              user.hasEmilyDRights ||
              (user.internal && user.site === ticket.siteConcerned) ||
              (user.externalMax && user.site === ticket.siteConcerned)) && (
              <Button
                size="small"
                disableRipple
                className={classes.button}
                color="secondary"
                onClick={handleHistoricOpenOrClose}
              >
                <Typography className={classes.collapseButton}>
                  {' '}
                  {t('Historic')}
                </Typography>
              </Button>
            )}
          </Grid>
        </Grid>
      </Grid>

      <GlobalTicketDetails
        ticket={ticket}
        expanded={expandedGlobalTicketDetails}
        handleChange={handleChange('globalTicketDetails')}
        statusError={statusError}
      />
      {(user.internal || user.hasEmilyDRights || user.externalMax) &&
        ticket.wagon && (
          <WagonDetails
            wagon={ticket.wagon}
            expanded={expandedWagonDetails}
            handleChange={handleChange('wagonDetails')}
          />
        )}
      <div>
        {ticket.anomalies !== undefined &&
          ticket.anomalies != null &&
          ticket.anomalies.map((anomaly, index) => {
            const anomalyId = `anomaly-${index}`;
            return (
              expandedAnomalyDetails.length > 0 && (
                <AnomalyDetails
                  anomaly={anomaly}
                  key={anomalyId}
                  expanded={expandedAnomalyDetails[index]}
                  handleChange={handleChange('anomalyDetails', index)}
                  validationErrors={anomalyErrors[index]}
                />
              )
            );
          })}
        {user.hasAllRights && (
          <div data-testid="invoices-list">
            <InvoicesList
              ticketNumber={ticketNumber}
              expanded={expandedInvoicesList}
              handleChange={handleChange('invoicesList')}
            />
          </div>
        )}
      </div>

      {(user.internal || user.hasEmilyDRights || user.externalMax) && (
        <div>
          <HistoricPopUp
            selectedTicketNumber={ticketNumber}
            historicOpened={historicOpened}
            setPopUpOpenedState={handleHistoricOpenOrClose}
          />
          <EmailPopUp
            open={emailOpened}
            ticketNumber={ticketNumber}
            triggerEmailPopUp={triggerEmailPopUp}
            setEmailPopUpOpenedState={handleEmailPopUpOpenOrClose}
          />
        </div>
      )}
      {displaySuccessPopup && requireMailNotification ? (
        <SuccessPopUp
          open={displaySuccessPopup}
          popupTitle={titleUpdateNotification}
          ticketNumber={ticketNumber}
          handleCloseSuccessPopUp={closeSuccessPopUp}
          handleEmailPopUp={handleEmailPopUpOpenOrClose}
        />
      ) : (
        <SuccessUpdateAlert
          successPopup={displaySuccessPopup}
          successMessage={titleUpdateNotification}
          handleCloseSuccessUpdateAlert={closeSuccessPopUp}
        />
      )}
    </div>
  );
}
